import { get } from "lodash";
import MainLoader from "./MainLoader";
import "./custom-components.style.scss";

const ModuleLoader = () => (
  <div className="wrapper_jr">
    <MainLoader />
  </div>
);

const Container = () => {
  const mainLoaderUrls = ["/", "/auth", "/logout", "/auth?logout"];
  const location = window.location;
  const pathName = get(location, "pathname", "/");
  let index = mainLoaderUrls.indexOf(pathName);
  return index !== -1 ? <MainLoader /> : <ModuleLoader />;
};

export default Container;
